import { gql } from '@apollo/client';

export default gql`
  query GetUserCredits($id: String!) {
    account(id: $id) {
      featureCredits {
        creditsRemaining
        resetDate
      }
    }
  }
`;
